import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { CoreModule } from '@app/core/core.module';
import { SharedModule } from '@app/shared/shared.module';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { SaveDataService } from '@app/shared/services/save-data.service';
import { AppService } from '@app/app.service';
import { TitleCode } from '@app/shared/interfaces/label-code.interface';

@Component({
    selector: 'app-preauthorized',
    standalone: true,
    imports: [CoreModule, CommonModule, SharedModule, TranslateModule],
    templateUrl: './preauthorized.component.html',
    styleUrl: './preauthorized.component.scss',
})
export class PreauthorizedComponent {
    continueButton = 'common.buttons.continueButton';

    authorizedTitle = 'features.authorized.authorizedTitle';
    authorizedSubTitle = 'features.authorized.authorizedSubTitle';

    preauthorizedTitle = 'features.preauthorized.preauthorizedTitle';
    preauthorizedSubTitle = 'features.preauthorized.preauthorizedSubTitle';

    onStudyTitle = 'features.onStudy.onStudyTitle';
    onStudySubTitle = 'features.onStudy.onStudySubTitle';

    sorryTitle = 'features.sorry.sorryTitle';
    sorrySubTitle = 'features.sorry.sorrySubTitle';
    sorryInfo = 'features.sorry.sorryInfo';

    operationResultOptions: TitleCode[] = [
        { code: '00', title: this.onStudyTitle, subtitle: this.onStudySubTitle },
        { code: '01', title: this.preauthorizedTitle, subtitle: this.preauthorizedSubTitle},
        { code: '02', title: this.sorryTitle, subtitle: this.sorrySubTitle},
        { code: '10', title: this.authorizedTitle, subtitle: this.authorizedSubTitle},
    ];

    selectedOperationResult: TitleCode = this.operationResultOptions[2];

    isPortraitDevice = false;

    private saveDataService = inject(SaveDataService);
    private appData = inject(AppService);

    formGroup!: FormGroup;
    numeroOperacion: any;


    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private changeStepService: ChangeStepService,
        private fb: FormBuilder,
    ) {
        this.changeStepService.changeStep(19);
    }

    ngOnInit() {
        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe((value) => {
            this.isPortraitDevice = value;
        });

        this.createForm();
        //this.setValuesForm(this.saveDataService.data);

        //this.formIsValid();
    }

    createForm() {
		this.formGroup = this.fb.group({
		        });
        this.numeroOperacion = this.appData.data.operationData?.subscriptionId;
        this.selectedOperationResult = this.findOperationResult(this.appData.data.operationData?.score.operationScore.subscriptionScore?.code) ?? this.operationResultOptions[2];
    }

    findOperationResult(code : string | undefined) {
        return this.operationResultOptions.find(option => option.code === code);
    }


    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//
    /*
  onClicButtonBack() {
    this.router.navigate(['/main/secure-financing'], { relativeTo: this.route });
  }
 */
    onClicButtonContinue() {
        this.router.navigate(['/main/step/bank-details'], { relativeTo: this.route });
    }
}
